/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Sendungen_Unknown_ErrorInputs */

const tr_geliver_sendungen_unknown_error = /** @type {(inputs: Geliver_Sendungen_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen hata`)
};

const en_geliver_sendungen_unknown_error = /** @type {(inputs: Geliver_Sendungen_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown error`)
};

const de_geliver_sendungen_unknown_error = /** @type {(inputs: Geliver_Sendungen_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Fehler`)
};

const ru_geliver_sendungen_unknown_error = /** @type {(inputs: Geliver_Sendungen_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестная ошибка`)
};

/**
* | output |
* | --- |
* | "Unknown error" |
*
* @param {Geliver_Sendungen_Unknown_ErrorInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_sendungen_unknown_error = /** @type {((inputs?: Geliver_Sendungen_Unknown_ErrorInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Sendungen_Unknown_ErrorInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_sendungen_unknown_error(inputs)
	if (locale === "de") return de_geliver_sendungen_unknown_error(inputs)
	if (locale === "ru") return ru_geliver_sendungen_unknown_error(inputs)
	return tr_geliver_sendungen_unknown_error(inputs)
});